import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da4dff3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-input-container" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = {
  key: 0,
  class: "emoji-container"
}
const _hoisted_5 = {
  key: 2,
  class: "sendoso-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  class: "sendoso-iframe",
  src: "https://app.sendoso.com/plugin/plugin_integrations",
  width: "435",
  height: "500"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close-sendoso-x",
  src: "/img/icons/x.svg",
  alt: "x"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "modal-group" }
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_At = _resolveComponent("At")!
  const _component_Picker = _resolveComponent("Picker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_At, {
      members: _ctx.members,
      class: "chat-at",
      "name-key": "name",
      ats: ['@', '#'],
      "filter-match": _ctx.filterMatch,
      "delete-match": _ctx.deleteMatch,
      onInsert: _ctx.onMentionAdded
    }, {
      item: _withCtx((scope) => [
        _createElementVNode("span", {
          class: "name",
          textContent: _toDisplayString(scope.item.name)
        }, null, 8, _hoisted_2),
        _createElementVNode("span", {
          class: "email",
          textContent: _toDisplayString(
                        scope.item.email !== undefined
                            ? scope.item.email
                            : scope.item.description
                    )
        }, null, 8, _hoisted_3)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: "quill-container",
          class: _normalizeClass(["chat-input", _ctx.customClass]),
          onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInputKeydown && _ctx.onInputKeydown(...args)))
        }, null, 34)
      ], undefined, true),
      _: 1
    }, 8, ["members", "filter-match", "delete-match", "onInsert"]),
    _createElementVNode("div", {
      class: _normalizeClass(['tools-container', _ctx.toolsCustomClass])
    }, [
      (!_ctx.disableEmoji)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "emoji",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickEmojiPicker && _ctx.onClickEmojiPicker(...args)))
            }),
            (_ctx.showEmojiPicker)
              ? (_openBlock(), _createBlock(_component_Picker, {
                  key: 0,
                  data: _ctx.emojiIndex,
                  class: "emoji-picker",
                  "emoji-size": 24,
                  "per-line": 9,
                  native: false,
                  set: "apple",
                  title: "pick an emoji",
                  emoji: "smile",
                  onSelect: _ctx.onSelectEmoji
                }, null, 8, ["data", "onSelect"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.htmlMode)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "link-container",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggerHyperlinkModal && _ctx.toggerHyperlinkModal(...args)))
          }))
        : _createCommentVNode("", true),
      (_ctx.isSendosoEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "sendoso",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickSendoso && _ctx.onClickSendoso(...args)))
            }, [
              _withDirectives(_createElementVNode("div", null, _hoisted_8, 512), [
                [_vShow, _ctx.showSendosoTool]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.maxTextLength)
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: _normalizeClass(["content-count", { 'over-limit': _ctx.contentLength > _ctx.maxTextLength }])
          }, _toDisplayString(_ctx.maxTextLength - _ctx.contentLength), 3))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Modal, {
      top: 20,
      padding: 24,
      size: _ctx.modalSize.Small,
      show: _ctx.showHyperlinkModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hyperlink) = $event)),
            type: "text",
            placeholder: "Paste link like https://asknice.ly"
          }, null, 512), [
            [_vModelText, _ctx.hyperlink]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Button, {
            class: "cancel",
            "no-border": "",
            onClick: _ctx.toggerHyperlinkModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "continue",
            onClick: _ctx.onOkHyperlink
          }, {
            default: _withCtx(() => [
              _createTextVNode("Link")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["size", "show"])
  ]))
}